import { render } from "./ViewerSearchResultResource.vue?vue&type=template&id=1a03adb6&scoped=true"
import script from "./ViewerSearchResultResource.vue?vue&type=script&lang=js"
export * from "./ViewerSearchResultResource.vue?vue&type=script&lang=js"

import "./ViewerSearchResultResource.vue?vue&type=style&index=0&id=1a03adb6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a03adb6"]])

export default __exports__